import {getEnvironment} from '~utils/index';

export function renderHTML(html) {
    let subdomain = getEnvironment() === 'LOCALHOST' ? 'dev' : getEnvironment().toLowerCase();
    let imagePath = `https://${subdomain}.plantvarieties.eu/static/images/html`;
    return (html || '').replace(/"IMAGES\/HTML/g, `"${imagePath}`).replace(/"images\/html/g, `"${imagePath}`);
}
